import AccountForm from './AccountForm';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const NewAccountModal = ({ isOpen, toggle, refresh }) => {
    return (
        <Modal
            className="text-light"
            isOpen={isOpen}
            centered
            style={{ minWidth: '50vw' }}>
            <ModalHeader>New Account</ModalHeader>
            <ModalBody>
                <AccountForm isNew={true} closeForm={toggle} refresh={refresh} />
            </ModalBody>
        </Modal>
    );
};

export default NewAccountModal;
